"use client";
import React from "react";
import { Typography, Box, Stack, Card, CardMedia, CardContent, CardActions } from "@mui/material";
import Grid from '@mui/material/Grid2';
import individuals from '../../assets/cards/individuals.png';
import businesses from '../../assets/cards/businesses.png';
import Button from '../common/Button';

const ProductsSection = () => {
  return (
    <Stack spacing={2} sx={{
          display: "flex",
          maxWidth: "1440px",
          flexDirection: "column",
          alignItems: "center",
          px: 1.5,
          margin: "0 auto",
          gap: "32px",
          width: "100%",
      }}>
          <Typography 
          variant="subtitle8"
          sx={{
              textTransform: "uppercase",
          }}>
            <Box component="span" sx={{ color: "darkPurple.500" }}>
              EXPLORE OUR{" "}
            </Box>
            <Box component="span" sx={{ color: "lightPurple.500" }}>
              products
            </Box>
          </Typography>
        
        {/* Fix: Modified Grid container to properly display cards in a row */}
        <Box sx={{ width: "100%" }}>
          <Grid container spacing={2} columns={12}>
            <Grid size={{xs: 12, md: 6}}>
              <ProductCard
                title="For individuals"
                titleColor="darkPurple.500"
                subtitle="See how we can help you"
                link="/individuals"
                bgColor="gray.100"
                svgBgColor="#beige.500"
                svgContent={individuals}
              />
            </Grid>

            <Grid size={{xs: 12, md: 6}}>
              <ProductCard
                title="For businesses"
                titleColor="darkPurple.500"
                subtitle="Solutions for a wide range of industries"
                link="/business"
                bgColor="gray.100"
                svgBgColor="lightPurple.200"
                svgContent={businesses}
              />
            </Grid>
          </Grid>
        </Box>
      </Stack>
  );
};

/**
 * ProductCard component displays a card with title, subtitle, button and SVG image
 */
interface ProductCardProps {
  title: string;
  titleColor: string;
  link: string;
  subtitle: string;
  bgColor: string;
  svgBgColor: string;
  svgContent: string;
}

const ProductCard: React.FC<ProductCardProps> = ({
  title,
  titleColor,
  link,
  subtitle,
  bgColor,
  svgBgColor,
  svgContent
}) => {
  return (
    <Card
      sx={{ 
        backgroundColor: bgColor,
        borderRadius: "12px",
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        height: "100%",
        overflow: "hidden",
        width: "100%"
      }}
    >
      <Box sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        padding: { xs: "32px 20px", md: "40px 0px 40px 48px" },
        flex: "1 1 50%",
        width: "100%",
        gap: {md: "32px", xs: "24px"}
      }}>
        <CardContent sx={{
          gap: "12px", 
          display: "flex", 
          flexDirection: "column",
          padding: 0
          }}>
          <Typography
            variant="subtitle8"
            sx={{ 
              color: titleColor,
              textTransform: "uppercase",
            }}
          >
            {title}
          </Typography>
          <Typography
            component="p"
            variant="body7"
            sx={{
              color: "gray.400",
              textTransform: "uppercase",
            }}
          >
            {subtitle}
          </Typography>
        </CardContent>
        <CardActions sx={{ padding: 0 }}>
          <Button href={link}>
            Learn more
          </Button>
        </CardActions>
      </Box>
      
      <CardMedia
  component="img"
  image={svgContent}
  sx={{
    backgroundColor: svgBgColor,
    height: "100%", 
    width: { xs: "100%", md: "45%" },
    flex: { xs: "0 0 auto", md: "0 0 45%" },
    maxHeight: {xs: "216px", md: "400px"},
    objectFit: "cover",
    objectPosition: "center"
  }}
      />
    </Card>
  );
};

export default ProductsSection;